import React from "react";

import "./Number.css";

export default class NumberEditor extends React.Component{
	constructor(props) {
		super(props);

		let { value, column } = props;

		this.state = {
			value,
			key: column.key,
		};

		this.inputRef = React.createRef();
	}

	getValue(){
		let { key, value } = this.state;
		return {
			[key]: value,
		};
	}

	getInputNode() {
		return this.inputRef.current;
	}

	// disableContainerStyles() {
	// 	// Optional method
	// 	// If set to true, the EditorContainer will not apply default styling to the editor
	// 	return true;
	// }

	render(){
		let { step, min, max, required } = this.props.column;

		return (
			<input
				ref = {this.inputRef}
				className = "number-editor"

				type = "number"
				step = {step}
				min = {min}
				max = {max}
				required = {required}

				value = {this.state.value}

				onChange = {(e) => {
					let targetValue = e.target.value?.trim();
					this.setState({ value: targetValue });
				}}
			/>
		);
	}
}
